<div class="pagination justify-content-end mb-0" style="padding: .25rem;"
  *ngIf="totalItems > itemsPerPage">
  <pagination
    [boundaryLinks]="true" [totalItems]="totalItems" [(ngModel)]="currentPage"
    [maxSize]="5" [rotate]="true" [itemsPerPage]="itemsPerPage"
    (pageChanged)="pageClick($event)"
    previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;">
  </pagination>
</div>
